<template>
  <MainLayout>
    <div class="parallax"
         data-parallax
         data-parallax-speed="0.25"
         data-parallax-direction="down">
      <div class="relative w-screen ">
        <img class="absolute -left-[1vw] top-[-12vh] w-[20vw] opacity-80" src="/images/bg-visual-left-top.webp" alt="">
        <img class="absolute -right-[6vw] top-[18vh] w-[30vw] opacity-60" src="/images/bg-visual-right-top.webp" alt="">
      </div>
    </div>

    <section id="hero">
      <div class="flex items-center lg:mt-[3rem] lg:mb-[2rem]">

        <div class="flex flex-col gap-y-4.5 lg:gap-y-8">
          <h1 class="text-[32px] leading-[36px] lg:text-[70px] lg:leading-[74px]  font-bold text-dark text-center font-markPro lg:max-w-[20ch] tracking-[-0.1rem]">
            {{ t('pages.info.downloads.title') }}
          </h1>

          <div class="flex flex-col gap-y-4">
            <div class="flex flex-col text-center leading-[27px] lg:text-lg font-semibold">
              <p class="text-lighter">
                {{ t('pages.info.downloads.subtext') }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
        <TransitionGroup>

          <div v-for="[os, {url, title,version}] in Object.entries(latestVersions)" :key="os"
               class="p-4 lg:px-6 lg:py-8 flex flex-col gap-y-16 bg-white rounded-2xl drop-shadow-lg" :class="{
                'border-3 border-primary/70': currentOs === os
             }">

            <div class="flex flex-col items-center">
              <h4 class="text-dark text-2xl font-bold">
                {{ t(`pages.info.downloads.operating_system.${os}`) }}
              </h4>

              <p class="text-lighter text-center text-lg">
                {{ t(`pages.info.downloads.supported_subversions.${os}`) }}
              </p>
            </div>

            <div class="flex justify-center items-center">
              <img class="h-32 w-fit"
                   v-if="os === 'mac_os'"
                   :src="publicPath('images/downloads/mac-logo.png')"
                   alt="MacOs">
              <img class="h-32 w-fit"
                   v-if="os === 'win'"
                   :src="publicPath('images/downloads/win-logo.png')"
                   alt="MacOs">
            </div>

            <p class="text-dark text-lg text-center">
              {{
                t(`pages.info.downloads.latest_version_text`, {
                  os: t(`pages.info.downloads.operating_system.${os}`),
                  version
                })
              }}

            </p>

            <div class="flex justify-center items-center">
              <a href="#" @click.prevent="handleDownloadFile(url)" class="btn btn-primary btn-xl lg:hover:scale-105">
                {{ t('pages.info.downloads.btn_text') }}
              </a>
            </div>

            <p class="text-center text-lighter text-sm">{{ title }}</p>
          </div>
        </TransitionGroup>
      </div>

    </section>

    <Transition>
      <section v-if="Object.keys(files).length > 0" id="previous-versions">
        <div class="flex items-center lg:mt-[3rem] lg:mb-[2rem]">

          <div class="flex flex-col gap-y-4.5 lg:gap-y-8">
            <h1 class="text-[32px] leading-[36px] lg:text-[70px] lg:leading-[74px]  font-bold text-dark text-center font-markPro lg:max-w-[20ch] tracking-[-0.1rem]">
              {{ t('pages.info.downloads.previous_versions_title') }}
            </h1>

            <div class="flex flex-col gap-y-4">
              <div class="flex flex-col text-center leading-[27px] lg:text-lg font-semibold">
                <p class="text-lighter">
                  {{ t('pages.info.downloads.previous_versions_subtext') }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full flex justify-center items-center gap-8 pb-32">

          <div class="p-4 lg:px-6 lg:py-8 flex flex-col gap-y-8 bg-white rounded-xl drop-shadow-lg w-full">
            <div class="flex flex-col gap-y-4" v-for="(versions,os) in files" :key="os">
              <a href="#"
                 class="flex justify-between items-center gap-x-4 pb-2 border-b border-neutral-200"
                 @click.prevent="dropdownOs === os ? dropdownOs = null : dropdownOs = os">

                <img class="w-8 h-8" v-if="os === 'mac_os'" :src="publicPath('images/downloads/mac-logo.png')" alt="MacOs">
                <img class="w-8 h-8" v-if="os === 'win'" :src="publicPath('images/downloads/win-logo.png')" alt="MacOs">

                <h4 class="grow w-full text-lg font-bold">{{ t(`pages.info.downloads.operating_system.${os}`) }}</h4>

                <i v-if="dropdownOs !== os" class="bi bi-chevron-down"></i>
                <i v-if="dropdownOs === os" class="bi bi-chevron-up"></i>
              </a>

              <div class="flex-col gap-y-4" :class="{
              'flex' : dropdownOs === os,
              'hidden' : dropdownOs !== os
            }">
                <div v-for="(versionFiles, version) in versions" class="border-b border-neutral-200 w-full">
                  <a href="#"
                     class="ml-4 font-bold text-lighter hover:text-primary transition-all ease-in-out flex justify-between"
                     @click.prevent="dropdownVersion === version ? dropdownVersion = null : dropdownVersion = String(version)">
                    {{ version }}

                    <i v-if="dropdownOs !== os || dropdownVersion !== version" class="bi bi-chevron-down"></i>
                    <i v-if="dropdownOs === os && dropdownVersion === version" class="bi bi-chevron-up"></i>
                  </a>

                  <div class="flex-col gap-y-2" :class="{
                  'flex' : dropdownOs === os && dropdownVersion === version,
                  'hidden' : dropdownOs !== os || dropdownVersion !== version
                }">

                    <div v-for="(file, title) in versionFiles" class="ml-8">
                      <a href="#"
                         @click.prevent="handleDownloadFile(file)"
                         class="appearance-none text-dark cursor-pointer lg:hover:text-primary transition-all ease-in-out">
                        {{ title }}
                      </a>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </section>
    </Transition>

  </MainLayout>
</template>

<script setup lang="ts">

import axios, { type AxiosResponse } from 'axios'
import { useHttp } from '@/composables/useHttp.ts'
import { onMounted, ref } from 'vue'
import MainLayout from '@/layouts/MainLayout.vue'
import { useI18n } from 'vue-i18n'
import { publicPath } from '@/utils/publicPath.ts'

type Platform = 'win' | 'mac_os'

type DownloadableFiles = Partial<{
  [key in Partial<Platform>]: {
    [version: string]: {
      [architecture: string]: string,
    }
  }
}>

type LatestVersions = Partial<{
  [key in Platform]: {
    url: string,
    title: string,
    version: string,
  }
}>

type DownloadsResponse = {
  data: {
    files: DownloadableFiles,
    latestVersions: LatestVersions
  }
}

const { t } = useI18n()
const http = useHttp()

const files = ref<DownloadableFiles>({})
const latestVersions = ref<LatestVersions>({})
const currentOs = ref<Platform>('win')

const dropdownOs = ref<Platform | null>(null)
const dropdownVersion = ref<string | null>(null)

const getOs = (): Platform => {
  if (import.meta.env.SSR) {
    return 'win'
  }

  if (window.navigator.userAgent.includes('Mac')) {
    return 'mac_os'
  }

  return 'win'
}

const loadDownloads = () => {
  http.get('downloads').then((res: AxiosResponse<DownloadsResponse>) => {
    files.value = res.data.data.files
    latestVersions.value = res.data.data.latestVersions
  })
}

const handleDownloadFile = (file: string) => {
  http.post('downloads', {
    path: file,
  }).then((res) => {
    const { url } = res.data.data
    window.location.href = url
  }).catch(err => {
    console.error(err)

    if (axios.isAxiosError(err)) {
      if (err.response?.data?.error) {
        alert(err.response.data.error)
      }
    }
  })
}

onMounted(() => {
  currentOs.value = getOs()
})

loadDownloads()

</script>

<style scoped>

</style>